<template>
	<div class="mt-8 flex-1 h-0 overflow-y-auto text-xl md:text-base">
		<nav class="px-4 space-y-2 md:space-y-1">
			<page-link
				v-for="item in items"
				:key="item.label"
				:href="item.href"
				:acl="item.acl_soft"
				:class="[
					'relative group flex items-center px-3 py-2 text-white font-medium rounded-2xl cursor-pointer',
					isActive(item)
						? 'md:bg-green bg-green-600 md:text-white'
						: 'hover:bg-green-600 md:hover:bg-gray-100 md:hover:text-gray-700',
						item.premiumRequired || item.disabled && !isActive(item)
						? 'md:text-gray-300'
						: 'md:text-gray-700'
				]"
				:cta="{
					code: 402,
					view: 'views/Modal/PremiumRequired'
				}"
				:absolute="true"
			>
				<ui-icon
					:class="[
						'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 md:h-5 md:w-5 text-inherit',
						// isActive(item) ? '' : 'md:text-gray-600',
						// item.highlight && !isActive(item) ? 'md:text-gray-300' : ''
					]"
					:name="item.icon"
					stroke-width="2"
					:classes="item.classes"

				/>
				{{ __(item.label) }}
				<span v-if="item.premiumRequired" class="ml-1 -mt-2">+</span>
				<!-- absolute top-0 right-0 translate-x-1/4 -translate-y-1/2 -->
				<span
					class="ml-3 inline-flex shadow-md md:shadow-none items-center justify-center px-3 py-2 md:px-2 md:py-1 text-base md:text-xs font-bold leading-none text-white transform bg-orange rounded-full"
					v-if="item.count"
					>{{ item.count }}</span
				>
			</page-link>
		</nav>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		let acl = this.$inertia.page.props.acl;
		return {
			acl: acl,
		};
	},
	mounted(){
		this.$bus.$on("menu:load", this.loadAcl);
	},
	beforeDestroy() {
		this.$bus.$off("menu:load", this.loadAcl);
	},
	methods: {
		loadAcl() {

			let promise = new Promise((resolve, reject) => {
				const response = axios.get(
					this.$route("user.acl")
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.acl = result.data.acl;
		},
		onError(error) {
			// todo prüfen
			window.location.reload();
		},
		isActive(item) {
			let url = this.$inertia.page.url;
			return url.match(item.activeIf || item.href) !== null;
		},
		isDenied(acl){
			return ! this.acl[acl];
		},
	},
	computed: {
		notifications() {
			let that = this;
			return this.$inertia.page.props.unreadMessages.map(function (m) {
				return {
					from: m.counterpart.company_name,
					text:
						m.type == "BID" ? __("You have received a new offer!") : m.message,
					link: that.$route("threads", { active_id: m.thread_id }),
				};
			});
		},
		unreadCount() {
			return this.notifications.length;
		},
		items() {
			return [
				{
					label: "Start",
					icon: "barn",
					href: this.$route('start.index'),
				},
				{
					label: "My Contracts",
					icon: "fa-handshake",
					href: this.$route('my_contracts.index'),
					acl: "contracts.read",
					premiumRequired: this.isDenied('contracts.read'),
				},
				{
					label: "My Lots",
					icon: "fa-wheat",
					href: this.$route('offer_all.index'),
					acl: "can_trade",
					disabled: this.isDenied('active_user')
				},
				{
					label: "My Negotiations",
					icon: "fa-messages",
					href: this.$route('threads'),
					acl: "can_trade",
					count: this.unreadCount,
					disabled: this.isDenied('active_user')
				},
				{
					label: "Auction",
					icon: "hammer",
					href: this.$route('auction.index'),
					acl: "can_auction",
					classes: "text-xl",
					hidden: this.isDenied('can_auction')
				},
				{
					label: "Price Ticker",
					icon: "fa-euro-sign",
					href: this.$route('price_indications.index'),
					acl: "price_indications.read",
					premiumRequired: this.isDenied('price_indications.read'),
					hidden: this.isDenied('subscriptions.read')
				},
				{
					label: "Search",
					icon: "fa-magnifying-glass",
					href: this.$route('search.index'),
				},
				{
					label: "Paper Market",
					icon: "fa-file-certificate",
					href: this.$route('paper.index'),
					hidden: this.isDenied('can_paper')
				},
				{
					label: "Market News",
					icon: "fa-chart-line-up",
					href: this.$route('content.compass'),
					acl: "market_news.read",
					premiumRequired: this.isDenied('market_news.read'),
					disabled: this.isDenied('active_user')
				},
				{
					label: "cropspot+",
					icon: "fa-circle-plus",
					href: this.$route('premium.index'),
					hidden: this.isDenied('subscriptions.read'),
				},
				{
					label: "Admin",
					icon: "sliders",
					href: this.$route('admin.users'),
					acl: "admin",
					hidden: this.isDenied('admin'),
				},
			].filter((item) => !item.hidden);
		},
	},
};
</script>
